<template>
  <button class="flk-back" type="button" @click="goBack" title="Back"><i class="mdi mdi-arrow-left"></i></button>
</template>

<script>
/* eslint-disable */
export default {
  name: "BackButton",
  props: {
    fallback: { type: String, default: "/dashboard" }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push(this.fallback);
    }
  }
};
</script>

<style>
.flk-back{width:36px;height:36px;border-radius:50%;border:none;background:rgba(128,128,128,.16);color:inherit;font-size:20px;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;line-height:1}
.flk-back:hover{background:rgba(191,161,100,.25);color:#BFA164}

/* Larger tap target on phones (Android guideline = 44dp+) */
@media (max-width: 768px) {
  .flk-back { width: 44px; height: 44px; font-size: 22px; }
}
</style>
